import { _, am5, am5radar, am5xy } from '@local/finsera-core/src/libs';

export const createAxes = ({ root, chart, maxValue }: { root: am5.Root; chart: am5xy.XYChart; maxValue: number }) => {
  const xRenderer = am5radar.AxisRendererCircular.new(root, {});
  xRenderer.labels.template.setAll({
    radius: 10,
    textType: 'adjusted',
    fontSize: 11,
    location: 0,
  });

  xRenderer.labels.template.adapters.add('text', function (text, target) {
    const dataItem = target.dataItem;
    if (dataItem) {
      const spoke = (dataItem.dataContext as any).spoke;
      if (spoke == 'annualized_ir') return 'Annualized IR';
      return _.startCase(spoke);
    }
    return text;
  });

  const xAxis = chart.xAxes.push(
    am5xy.CategoryAxis.new(root, {
      maxDeviation: 0,
      categoryField: 'spoke',
      renderer: xRenderer,
    })
  );

  const yAxis = chart.yAxes.push(
    am5xy.ValueAxis.new(root, {
      renderer: am5radar.AxisRendererRadial.new(root, {
        disabled: true,
      }),
      max: maxValue * 1.1,
      min: 0,
    })
  );

  yAxis.get('renderer').grid.template.set('forceHidden', true);
  yAxis.get('renderer').labels.template.set('forceHidden', true);

  return { xAxis, yAxis };
};
